import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Michael Irigoyen
 * id 020A5F88-EE7B-4FE7-ADC7-999A0ADB16EE
 * name checkerboard-plus
 * version: 4.6.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/checkerboard-plus.svg
 * tags
 * - Geographic Information System 
 */
export const CheckerboardPlusIcon = createSvgIcon(<><path d="M19 17H22V19H19V22H17V19H14V17H17V14H19V17M8 16H12V12H8V16M12 12H16V8H12V12M2 2V22H13.54C13 21.42 12.63 20.74 12.36 20H8V16H4V12H8V8H4V4H8V8H12V4H16V8H20V12.36C20.74 12.63 21.42 13 22 13.54V2H2Z" /></>, 'CheckerboardPlusIcon');
export default CheckerboardPlusIcon